import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import * as React from 'react'
import UnderlineInput from './InputField/UnderlineInput'
import TinyLabel from './TinyLabel'










const Label = styled(TinyLabel)({
  fontSize: 12,
  fontWeight: 600
})

const PasswordInputField = (props) => {
  const {autoFocus, dirty, error, onChange, onBlur, value} = props
  return (
    _jsxs(React.Fragment, { children: [
      _jsx(Label, { children: "Password"})
      , _jsx(UnderlineInput, {
        ariaLabel: 'Password',
        autoComplete: "current-password",
        autoFocus: autoFocus,
        error: dirty ? (error ) : undefined,
        name: "password",
        onBlur: onBlur,
        onChange: onChange,
        placeholder: "********",
        type: "password",
        value: value,}
      )
    ]})
  )
}

export default PasswordInputField
